import { useSearchParams } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import CustomerManagement from '@/components/CustomerManagement';
import Suppliers from '@/pages/Suppliers';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

export default function Contacts() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'suppliers' ? 'suppliers' : 'customers';
  return <><PageHeader title="Pelanggan & Supplier" subtitle="Revisi nama dan kontak tanpa mengubah riwayat transaksi." />
    <Tabs value={tab} onValueChange={value => setParams({tab:value})} className="flex-1 min-h-0 flex flex-col">
      <TabsList className="m-4 grid grid-cols-2 max-w-md shrink-0"><TabsTrigger value="customers">Pelanggan</TabsTrigger><TabsTrigger value="suppliers">Supplier</TabsTrigger></TabsList>
      <div className="flex-1 min-h-0 overflow-y-auto px-4 pb-4"><TabsContent value="customers"><CustomerManagement /></TabsContent><TabsContent value="suppliers"><Suppliers /></TabsContent></div>
    </Tabs>
  </>;
}
